import { E2E_STORAGE_KEY } from './e2e'

/**
 * Clears all localStorage items
 *
 * @param whitelist - any items with this key (and our prefix) will be kept
 */

const calloutWhitelist = [
  'hidePageMessage-profile-notifications',
  'hidePageMessage-client-notifications',
  'hidePageMessage-company-settings',
  'hidePageMessage-account-branding',
  'hidePageMessage-settings-quote-settings',
  'hidePageMessage-settings-quote-types',
  'hidePageMessage-settings-estimate-disclaimers',
  'hidePageMessage-settings-quote-templates',
  'hidePageMessage-estimate-tags',
  'hidePageMessage-invoice-settings',
  'hidePageMessage-settings-rates',
  'hidePageMessage-area-names',
  'hidePageMessage-settings-products',
  'hidePageMessage-settings-line-items',
  'hidePageMessage-settings-terms',
  'hidePageMessage-settings-presentations',
  'hidePageMessage-communications-email-templates',
  'hidePageMessage-communications-email-automations',
  'hidePageMessage-settings-follow-ups',
  'hidePageMessage-profile-follow-ups',
  'hidePageMessage-profile-chat',
  'hidePageMessage-settings-sources',
  'hidePageMessage-settings-team',
  // persist table column preferences across logouts
  'dealTableColumns',
  'quoteTableColumns',
  'taskTableColumns'
]

export function clearLocalStorage(options: { whitelist?: string[]; whiteListPartialMatch?: string[] } = {}) {
  const { whitelist = [], whiteListPartialMatch = [] } = options
  const localStorageKeys = Object.keys(window.localStorage)

  // `ps-e2e` marks the session as an automated BugBug run (see `isE2E`). BugBug sets it once, right
  // after the initial `Go to URL`, so a mid-test logout must not wipe it — otherwise the rest of the
  // run would look like a real user and start recording session replays.
  const entireWhitelist = ['lastLogin', 'authRedirectUrl', E2E_STORAGE_KEY, ...whitelist, ...calloutWhitelist]

  localStorageKeys.forEach((key) => {
    if (entireWhitelist.indexOf(key) === -1 && !whiteListPartialMatch.some((partial) => key.includes(partial))) {
      window.localStorage.removeItem(key)
    }
  })
}
